import * as React from "react";

import { Input } from "@/components/ui/input";

/** Campo numerico "de caixa registradora": digita da DIREITA pra esquerda.
 *  Comeca em 0,000 e cada digito entra pela direita (1 → 0,001; 18 → 0,018;
 *  180 → 0,180). `value` e' string numerica com ponto ("0.18") ou "";
 *  `onChange` recebe a mesma forma. `decimals` = casas (3 = kg, 2 = %, 0 = inteiro). */
const InputDecimal = React.forwardRef(function InputDecimal(
  { value, onChange, decimals = 3, sufixo, className = "", ...props }, ref,
) {
  const fator = 10 ** decimals;
  const n = Number(value);
  const digitos = value === "" || value == null || !Number.isFinite(n) ? "" : String(Math.round(n * fator));
  const exibir = (d) => {
    const num = (Number(d || "0") / fator).toFixed(decimals);
    const [int, dec] = num.split(".");
    const intFmt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return dec != null ? `${intFmt},${dec}` : intFmt;
  };
  const emitirDigitos = (d) => onChange(d === "" ? "" : String(Number(d) / fator));
  // Caixa registradora: cada tecla numerica ENTRA pela direita e Backspace tira
  // da direita, independente de onde o cursor esteja. Tratar no keydown (e nao
  // no onChange) e' o que torna isso deterministico — clicar no meio de "0,000"
  // e digitar nao insere no meio. onChange fica so pra colar/teclado virtual.
  const aoTeclar = (e) => {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (/^\d$/.test(e.key)) {
      e.preventDefault();
      emitirDigitos((digitos + e.key).replace(/^0+(?=\d)/, "").slice(-12));
    } else if (e.key === "Backspace") {
      e.preventDefault();
      emitirDigitos(digitos.slice(0, -1));
    } else if (e.key === "Delete") {
      e.preventDefault();
      emitirDigitos("");
    }
    props.onKeyDown?.(e);
  };
  const aoDigitar = (e) => {
    const d = e.target.value.replace(/\D/g, "").replace(/^0+(?=\d)/, "").slice(-12);
    emitirDigitos(d);
  };
  const inputRef = React.useRef(null);
  React.useImperativeHandle(ref, () => inputRef.current);
  const paraOFim = (el) => { if (!el) return; const n = el.value.length; try { el.setSelectionRange(n, n); } catch { /* sem selecao */ } };
  React.useLayoutEffect(() => {
    const el = inputRef.current;
    if (el && document.activeElement === el) paraOFim(el);
  }, [digitos]);
  const { onFocus, onClick, onKeyDown: _k, ...resto } = props;
  return (
    <div className="relative">
      <Input ref={inputRef} type="text" inputMode={decimals > 0 ? "decimal" : "numeric"} value={exibir(digitos)}
        onChange={aoDigitar} onKeyDown={aoTeclar}
        onFocus={(e) => { const el = e.target; requestAnimationFrame(() => paraOFim(el)); onFocus?.(e); }}
        onClick={(e) => { paraOFim(e.target); onClick?.(e); }}
        className={`text-right tabular-nums ${sufixo ? "pr-10" : ""} ${className}`} {...resto} />
      {sufixo && <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground pointer-events-none">{sufixo}</span>}
    </div>
  );
});

export { InputDecimal };
